export default "__VITE_ASSET__CW$6jyPd__"